<template>
    <van-dialog class="add_wechat" v-model="openFeedback" :showConfirmButton="false">
        <template slot="title">
            <div class="close-pop" @click="closeFeedback">
                <img src="/static/bytx/popup_close_icon.svg" alt="">
            </div>
            <h3 v-if="apply">您已申请成功！</h3>
            <h3 v-else>您已注册成功！</h3>
        </template>
        <div class="clear"></div>
        <div v-if="apply">请将项目名发给小助手，获取报名表或链接</div>
        <div v-else>
            想了解更多问诊、新药、经济救助、战友群等患友服务，添加小助手
        </div>
        <div class="add_wechat_kf" align="center" style="margin-top: 12px;color: #9D9D9D">
            <img :src="qrcode" alt="">
            <br>
            长按识别添加
        </div>
    </van-dialog>
</template>

<script type="text/ecmascript-6">
    export default {
        name: 'add_wechat',
        props : {
            openFeedback : {
                type : Boolean,
                default : false,
            },
            qrcode : {
                type : String,
            },
            apply: {
                type : Boolean,
                default : false,
            }
        },
        methods: {
            closeFeedback(){
                this.$emit("func",{})
                sessionStorage.removeItem("init_complete")
            },
        }
    }
</script>
<style>
    .add_wechat{
        width: 300px;
        text-align: left;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #404040;
        letter-spacing: 0;
        line-height: 22px;
        padding: 0 20px 20px;
    }

    .add_wechat .close-pop{
        float: right;
        margin-right: 10px;

    }

    .add_wechat_kf img{
        width: 180px;
        height: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/add_wechat.vue